// extracted by mini-css-extract-plugin
export default {"main-container":"all-patients_main-container__IJvCQ","patients-list":"all-patients_patients-list__M5ROC","patients-list__container":"all-patients_patients-list__container__TxU2a"};